import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section-title group-hover:text-brand-600" }
const _hoisted_2 = { class: "overflow-auto pb-4" }

import {
		ref
	} from 'vue'
	// #endregion

	
// name the component
	const __default__ = { name: 'CollapsableCard' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		title: {
			type: String,
			default: ""
		},
		openByDefault: {
			type: Boolean,
			default: true
		},
		noFill: {
			type: Boolean,
			default: false
		},
		fixed: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {


	// #region imports
	// Vue
	const props = __props

	const expanded = ref<boolean>(props.openByDefault)



return (_ctx: any,_cache: any) => {
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["h-full w-full", [props.noFill ? '' : 'card']])
  }, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value || __props.fixed)),
      class: "p-4 pb-0 w-full group cursor-pointer flex justify-between items-center"
    }, [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(props.title), 1),
      (!__props.fixed)
        ? (_openBlock(), _createBlock(_component_ChevronDownIcon, {
            key: 0,
            class: _normalizeClass(["stroke-black stroke-2 ml-1 w-5 h-5 transition-all text-brand-500 ease-in-out group-hover:stroke-brand-600", {'-rotate-90': !expanded.value}])
          }, null, 8, ["class"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["accordian pt-4 w-full", {'-mt-1000%': !expanded.value, 'mt-0': expanded.value}])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ])
  ], 2))
}
}

})